export default __webpack_public_path__ + "static/media/le_mont2.01ebc826.jpg";